import { render, staticRenderFns } from "./Graveyard.vue?vue&type=template&id=038adfdc"
import script from "./Graveyard.vue?vue&type=script&lang=js"
export * from "./Graveyard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports